import { Context } from "../../../types/Context";
import { FormDefinition } from "../../../types/Forms";
import { Client } from "../Client";
import { APIRequest, APIRequestMethod } from "../APIRequest";
import { GraphicalPDFFormPages } from "../../../types/Forms/FieldTypes/GraphicalPDFFormField";
import { FormValue } from "../../../types/Forms/FormValue";
import { FormSubmissionResponse, FormSubmissionValidationState } from "../../../types/Forms/FormSubmissionResponse";
import { Logger, LogLevel } from "../../Logger";
import { IRequestProgressDelegate } from "../IRequestProgressDelegate";

class FormAPI {
    GetForm(type: string, context: Context): Promise<FormDefinition> {
        return Client.Request(new APIRequest(APIRequestMethod.POST, '/api/forms/get', {
            type: type,
            context: context
        }));
    }

    GetPDFFieldPage(type: string, context: Context, fieldKey: string, page: number): Promise<Response> {
        return Client.RawRequest(new APIRequest(APIRequestMethod.POST, "/api/forms/get_pdf_page", {
            type: type,
            context: context,
            fieldKey: fieldKey,
            page: page
        }));
    }

    GetPDFFields(type: string, context: Context, fieldKey: string): Promise<GraphicalPDFFormPages> {
        return Client.Request(new APIRequest(APIRequestMethod.POST, '/api/forms/get_pdf_fields', {
            type: type,
            context: context,
            fieldKey: fieldKey
        }));
    }

    ValidateSection(type: string, context: Context, values: FormValue[], sectionIndex: number): Promise<FormSubmissionValidationState> {
        return Client.Request(new APIRequest(APIRequestMethod.POST, '/api/forms/validate_section', {
            type: type,
            context: context,
            values: values.filter(v => !(v.Value instanceof Blob)), // Filter out blobs
            sectionIndex: sectionIndex
        }));
    }

    SubmitForm(type: string, context: Context, values: FormValue[], progressDelegate?: IRequestProgressDelegate): Promise<FormSubmissionResponse> {
        //Check to see if we should use the FormData or JSON method

        if(values.some(v => v.Value instanceof Blob)) {
            //FormData uploader
            Logger.Log(LogLevel.Debug, '[Form]', 'Using multipart uploader');

            var fd = new FormData();

            fd.append('model', JSON.stringify({
              type: type,
              context: context,
              values: values.filter(v => !(v.Value instanceof Blob))
            }));

            values.filter(v => v.Value instanceof Blob).forEach(blobVal => {
              var name = 'blob';

              if ('name' in (blobVal.Value as any)) {
                name = (blobVal.Value as any).name;
              }

              fd.append('blob_' + blobVal.Key, blobVal.Value as Blob, name);
            });

            //return Client.Request(new APIRequest(APIRequestMethod.POST, '/api/forms/submit_multipart', fd));
            return Client.XHR(new APIRequest(APIRequestMethod.POST, '/api/forms/submit_multipart', fd), progressDelegate);
        } else {
            return Client.Request(new APIRequest(APIRequestMethod.POST, '/api/forms/submit', {
              type: type,
              context: context,
              values: values
            }));
        }
    }
}

export { FormAPI }
